import { render, staticRenderFns } from "./CreateCommunityModal.vue?vue&type=template&id=8d9b93a8&scoped=true"
import script from "./CreateCommunityModal.vue?vue&type=script&lang=js"
export * from "./CreateCommunityModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCommunityModal.vue?vue&type=style&index=0&id=8d9b93a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9b93a8",
  null
  
)

export default component.exports